import styled from "styled-components"
import { Link } from "react-router-dom"

export const Container = styled.div`
    background-color: var(--medGrey);
    display: flex;
`

export const Wrapper = styled.div`
    flex: 1;
`

export const Main = styled.div`
    margin-top: 10px;
    flex: 4;
    color: var(--darkGrey);
    padding: 20px;
`

export const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const Title = styled.h1`
`

export const TitleButton = styled.button`
    margin-top: 10px;
    width: 80px;
    border: none;
    padding: 5px;
    background-color: var(--primary);
    color: var(--white);
    border-radius: 5px;
    font-size: var(--fontM);
    cursor: pointer;
`

export const GridWrapper = styled.div`
    display: flex;
    margin: 20px 0px;
    background-color: var(--darkGrey);
`

export const ProductColumn = styled.div`
    display: flex;
    align-items: center;
`

export const ProductImage = styled.img`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 10px;
    background-color: var(--medGrey);
`

export const Action = styled.div`
    display: flex;
    align-items: center;
`

export const StyledLink = styled(Link)`
`

export const StyledButton = styled.button`
    border: none;
    border-radius: 10px;
    padding: 5px 10px;
    background-color: var(--primary);
    color: var(--lightGrey);
    cursor: pointer;
    margin-right: 10px;
`

export const StyledIcon = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`

export const Message = styled.div`
    margin-top: 20px;
    color: var(--secondary);
`